import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import ParticleField from "@/components/ParticleField";
import { useContent } from "@/context/ContentContext";

export default function PoweredBy() {
  const { content } = useContent();
  return (
    <div>
      <SEO title="Powered by ImJove Tech" description="What it means to be Powered by ImJove Tech — the connecting layer across an entire technology ecosystem." />
      <section className="relative flex min-h-[80vh] items-center overflow-hidden pt-28">
        <ParticleField className="absolute inset-0 z-0" density={45} />
        <div className="radial-fade absolute inset-0" />
        <div className="relative z-10 mx-auto max-w-[1100px] px-6 text-center md:px-12">
          <Reveal>
            <div className="mx-auto flex h-24 w-24 items-center justify-center">
              <img src={content.logo_url} alt="ImJove Tech" className="animate-floaty h-24 w-24 object-contain drop-shadow-[0_0_30px_rgba(212,175,55,0.4)]" />
            </div>
            <p className="mt-8 font-mono2 text-xs uppercase tracking-brand text-white/40">Powered by</p>
            <h1 className="mt-3 font-display text-6xl font-bold tracking-tighter text-gold-gradient sm:text-7xl">ImJove Tech</h1>
            <p className="mx-auto mt-8 max-w-2xl font-body text-lg leading-relaxed text-white/60">
              Every ImJove product carries its own identity — but all are connected by one ecosystem. The "Powered by ImJove Tech" badge signals that a platform is built, backed, and evolved by ImJove Tech and Jove Divinity.
            </p>
            <p className="mx-auto mt-4 max-w-2xl font-body text-white/45">
              Wherever you see the badge, clicking it brings you back here — to the digital headquarters connecting AI, nightlife, culinary, fintech, virtual worlds, and future hardware.
            </p>
            <Link to="/universe" className="btn-gold mt-10 inline-flex items-center gap-2 rounded-full px-8 py-4 font-mono2 text-[12px] font-semibold uppercase tracking-widest">
              Explore the ImJove Universe <ArrowRight size={15} />
            </Link>
          </Reveal>
        </div>
      </section>

      <section className="border-t border-white/10 bg-ink-800 py-24">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12">
          <div className="grid gap-6 md:grid-cols-3">
            {[
              { t: "The Parent Company", d: "ImJove Tech is the parent technology and innovation company behind every ImJove platform." },
              { t: "The Connecting Layer", d: "Each product keeps its own brand while ImJove Tech connects them into one ecosystem." },
              { t: "A Universal Badge", d: "Designed to live on every ImJove website and product as a mark of the ecosystem." },
            ].map((c, i) => (
              <Reveal key={c.t} delay={i * 0.08}>
                <div className="h-full rounded-2xl border border-white/10 bg-ink-900 p-8">
                  <h3 className="font-display text-xl font-semibold text-white">{c.t}</h3>
                  <p className="mt-3 font-body text-white/55">{c.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
